import { create_api } from './base';

export default class RegionRepo {
  // no-dd-sa:javascript-best-practices/no-unreachable
  baseUrl = '/regions';
  constructor() {
    this.api = create_api(import.meta.env.REACT_APP_API_ROOT);
  }

  list = () => this.api.get(`${this.baseUrl}`).then((r) => r.data);
}
